import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchRegular = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 2.25C7.06294 2.25 2.25 7.06294 2.25 13C2.25 18.9371 7.06294 23.75 13 23.75C15.6986 23.75 18.165 22.7556 20.0527 21.1133L28.4697 29.5303C28.7626 29.8232 29.2374 29.8232 29.5303 29.5303C29.8232 29.2374 29.8232 28.7626 29.5303 28.4697L21.1133 20.0527C22.7556 18.165 23.75 15.6986 23.75 13C23.75 7.06294 18.9371 2.25 13 2.25ZM3.75 13C3.75 7.89137 7.89137 3.75 13 3.75C18.1086 3.75 22.25 7.89137 22.25 13C22.25 18.1086 18.1086 22.25 13 22.25C7.89137 22.25 3.75 18.1086 3.75 13Z",
		fill: "currentColor"
	})
});
export default SvgSearchRegular;
